import { render } from "./SubHeader.vue?vue&type=template&id=d1b0bc24&scoped=true"
import script from "./SubHeader.vue?vue&type=script&lang=js"
export * from "./SubHeader.vue?vue&type=script&lang=js"

import "./SubHeader.vue?vue&type=style&index=0&id=d1b0bc24&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d1b0bc24"

export default script